import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    return (
        <div
            className={cn(
                "tw:flex tw:flex-row tw:font-bold tw:justify-between tw:mb-2",
                className
            )}
        >
            {children}
        </div>
    );
};
